import { PageContainer } from '@components';
import { User } from '@views/User';
import { useEffect } from 'react';
import { store } from '@store';
import { Loader } from '@components/utils';

const UserPage = () => {
  const user = store.use.user();
  const getUserAction = store.use.getUserAction().call;
  const isLoading = store.use.getUserAction().status === 'LOADING';

  useEffect(() => {
    getUserAction();
  }, []);

  return (
    <PageContainer>
      {isLoading && <Loader />}
      {!isLoading && <User user={user} />}
    </PageContainer>
  );
};

export default UserPage;
